<template>
    <aside class="col-lg-3 col-xl-3 sidebar">
        <div class="sidebar-holder">

            <div class="sidebar-box border-0 pb-0">
                <strong class="h2 text-uppercase">PINNED COMPETITIONS</strong>
                <div class="sidebar-box-inner">
                    <ul class="pinup-list" v-if="$store.getters.pinnedLeagues.length != 0 || $store.getters.pinnedIccTypes.length != 0">
                        <li class="pin-active" v-for="pin in $store.getters.pinnedLeagues" :key="pin.id">
                        <router-link  onclick="closeBurger()" :to="{ name: 'tournamentDetail.Matches', params: { tournament: pin.slug } }" class="pin-title">
                                      {{ pin.name }}
                    </router-link>
                    <span @click.stop="$store.commit('removePinnedLeague', pin)" class="pin-btn"><i class="ico-unpin"></i></span>
                    </li>
                    <li class="pin-active" v-for="type in $store.getters.pinnedIccTypes" :key="type">
                    <router-link  onclick="closeBurger()" :to="{ name: 'allMatches', params: {date : date , icc: `${type.slugify()}` } }" class="pin-title">
                                  ICC {{ type }}
                </router-link>
                <span @click.stop="$store.commit('removePinnedIccType', type)" class="pin-btn"><i class="ico-unpin"></i></span>
                </li>
            </ul>
            <span v-else class="px-10">No pinned competitions yet.</span>
        </div>
    </div>
    <div class="sidebar-box">
        <strong class="h2">COUNTRIES</strong>
        <div class="sidebar-box-inner text-center" v-if="!is_data_ready">
            <span class="loader"></span>
        </div>
        <div class="sidebar-box-inner" v-else>
            <ul class="accordion countries-accordion" id="countries-accordion">
                <li>
                    <a class="ac-opener" data-toggle="collapse" :href="`#countriesCollapseICC`" aria-expanded="false">
                        <span class="icon-wrap"><img  loading="lazy" width="26" height="26" class="lazyload" :src="($storageURL + 'country_flags/International.png').resizeImage(36,36)" alt="ICC" /></span>
                        <span class="title">International</span>
                    </a>
                    <div class="collapse" :id="`countriesCollapseICC`" data-parent="#countries-accordion">
                        <ul class="pinup-list">
                            <li
                                v-for="type in ['Test Match','ODI', 'T20I',  'Youth ODI', 'Youth T20', 'Youth Test','List A ODI', 'List A T20', 'List A TEST']" :key="type"
                                :class="$store.getters.isIccTypePinned(type) ? 'pin-active': null">
                        <router-link  onclick="closeBurger()" :to="{ name: 'allMatches', params: { date: date, icc: `${type.slugify()}` } }" class="pin-title">
                            International {{ type }}
                    </router-link>
                    <span @click.prevent="togglePinnedIcc(type)" class="pin-btn"><i class="ico-unpin"></i></span>
                    </li>
                </ul>
            </div>
        </li>
        <li v-for="(country, index) in top10Countries" :key="country.id" 
            :class="$store.getters.isCountryPinned(country) ? 'pin-active' : null">
            <div class="ac-opener-wrap">
                <a class="ac-opener" data-toggle="collapse" :href="`#countriesCollapseTop${index}`" aria-expanded="false">
                    <span class="icon-wrap"><img width="26" height="26" loading="lazy" class="lazyload" :src="country.flag.resizeImage(36,36)" :alt="country.name" /></span>
                    <span class="title">{{ country.name }}</span>
                </a>
                <span @click.prevent="togglePinnedCountry(country)" class="pin-btn"><i class="ico-unpin"></i></span>
            </div>
            <div class="collapse" :id="`countriesCollapseTop${index}`" data-parent="#countries-accordion">
                <ul class="pinup-list">
                    <li
                        :class=" $store.getters.isLeaguePinned(tournament) ? 'pin-active': null"
                        v-for="tournament in country.tournaments"
                        :key="tournament.id"
                        >
                <router-link onclick="closeBurger()"
                             :to="{ name: 'tournamentDetail.Matches', params: { tournament: tournament.slug } }"
                             class="pin-title"
                             >
                             {{ tournament.name }}
            </router-link>
            <span @click.prevent="togglePinned(tournament, country)" v-if="!tournament.category.startsWith('intl_')" class="pin-btn"><i class="ico-unpin"></i></span>
            </li>
        </ul>
    </div>
</li>
<li v-for="(country, index) in Object.values(countries).sort((a, b) => a.name < b.name ? -1 : 1)" :key="country.id" :class="$store.getters.isCountryPinned(country) ? 'pin-active': null">
    <div class="ac-opener-wrap">
        <a class="ac-opener" data-toggle="collapse" :href="`#countriesCollapse${index}`" aria-expanded="false">
            <span class="icon-wrap"><img loading="lazy" width="26" height="26" class="lazyload" :src="country.flag.resizeImage(36,36)" :alt="country.name" /></span>
            <span class="title">{{ country.name }}</span>
        </a>
        <span @click.prevent="togglePinnedCountry(country)" class="pin-btn"><i class="ico-unpin"></i></span>
    </div>
    <div class="collapse" :id="`countriesCollapse${index}`" data-parent="#countries-accordion">
        <ul class="pinup-list">
            <li
                :class="$store.getters.isLeaguePinned(tournament) ? 'pin-active': null"
                v-for="tournament in country.tournaments"
                :key="tournament.id"
                >
        <router-link  onclick="closeBurger()"
                      :to="{ name: 'tournamentDetail.Matches', params: { tournament: tournament.slug } }"
                      class="pin-title"
                      >
                      {{ tournament.name }}
    </router-link>
    <span @click.prevent="togglePinned(tournament, country)" v-if="!tournament.category.startsWith('intl_')" class="pin-btn"><i class="ico-unpin"></i></span>
    </li>
</ul>
</div>
</li>
</ul>
</div>
</div>
<!-- <div class="sidebar-box">
        <strong class="h2 text-uppercase">FOLLOW US</strong>
        <div class="sidebar-box-inner">
                <socialMedia />
        </div>
</div> -->
</div>
</aside>
</template>

<script>
//    import SocialMedia from './_SocialMedia'

    export default {
        name: 'leftSidebar',

        components: {
//            SocialMedia
        },

        data() {
            return {
                date: this.$route.params.date,
                countries: [],
                topCountries: []
            }
        },

        watch: {
            $route(to, from) {
                if(isBrowser) {
                    this.date = to.params.date;
                }
            }
        },

        computed: {
            top10Countries() {
                let sorting = ['India', 'New Zealand', 'Australia', 'England', 'Pakistan', 'South Africa', 'Sri Lanka', 'West Indies', 'Bangladesh', 'Zimbabwe']

                return this.topCountries.map(item => {
                    let n = sorting.indexOf(item.name)
                    sorting[n] = ''
                    return [n, item]
                })
                        .sort().map(j => j[1])
            }
        },

        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
//            this.$root.$on('date', (text) => { // here you need to use the arrow function
//                this.date = text;
//            }),
                    this.main();
        },

        methods: {
            main() {
                return this.$axios
                        .get(this.$COUNTRY_TOURNAMENTS_API)
                        .then(response => {
                            this.is_data_ready = true
                            this.countries = response.data.result.countries || []
                            this.topCountries = response.data.result.topCountries || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
            togglePinned(tournament, country) {
                this.$store.commit(this.$store.getters.isLeaguePinned(tournament) ? 'removePinnedLeague' : 'addPinnedLeague', {
                    ...tournament,
                    ...{country_name: country.name, country_flag: country.flag}
                })
            },

            togglePinnedIcc(type) {
                this.$store.commit(
                        this.$store.getters.isIccTypePinned(type) ? 'removePinnedIccType' : 'addPinnedIccType',
                        type
                        )
            },

            togglePinnedCountry(country) {
                if (this.$store.getters.isCountryPinned(country)) {
                    country.tournaments.forEach(tournament => {
                        this.$store.commit('removePinnedLeague', {...tournament, ...{country_name: country.name, country_flag: country.flag}})
                    })
                } else {
                    country.tournaments.forEach(tournament => {
                        if (!this.$store.getters.isLeaguePinned(tournament) && (!['intl_test', 'women_test', 'youth_int_test', 'EMG_Test', 'intl_t20', 'youth_int_t20i', 'women_t20i', 'women_t20', 'List_A_T20I', 'EMG_T20', 'intl_odi', 'youth_int_odi', 'women_odi', 'List_A_ODI', 'List_A_ODI_women', 'EMG_ODI'].includes(tournament.category))) {
                            this.$store.commit('addPinnedLeague', {...tournament, ...{country_name: country.name, country_flag: country.flag}})
                        }
                    })
                }
            }
        }
    }
</script>
